import React, { useState, useEffect } from "react";
import './LeftNav.css';
import { useSelector, useDispatch } from "react-redux";
import { setFFR, setFFRCalculationStatus, setHeartRate, setPrintCamera, setVesselInfo, setModelType, setLvMyocardiumMass, setActiveVessel } from "../Store/LoadReducer";
import { modelPollingPromise } from "../../helpers/utils";
// TODO: CFD supplementary is disabled for now
// import CFDSupplementary from "./CFDSupplementary";
import PINNSupplementary from "./PINNSupplementary";
import PINNGeneral from "./PINNGeneral";
import { setOverlayStatus, setFile } from "../Store/LoadReducer";
import { formatInputNumber, fileStorage } from "../../helpers/utils";

function LeftNav() {
    const radii = useSelector(item => item.flowviewer.radii);
    const bifurcations = useSelector(item => item.flowviewer.bifurcations);
    const heartRate = useSelector(item => item.flowviewer.heart_rate);
    const lvMyocardiumMass = useSelector(item => item.flowviewer.lv_myocardium_mass);
    const [lvMyocardiumMass_, setLvMyocardiumMass_] = useState(lvMyocardiumMass ? formatInputNumber(lvMyocardiumMass) : false);
    const supplementary = useSelector(item => item.flowviewer.supplementary);
    const modelType = useSelector(item => item.flowviewer.modelType);
    const vesselJSON = useSelector(item => item.flowviewer.vesselJSON);
    const uploadedVessels = useSelector(item => item.flowviewer.uploadedVessels);
    const activeVessel = useSelector(item => item.flowviewer.activeVessel);
    const dispatch = useDispatch();


    function calculateKHyperemia(stenosis_d, age) {
        let hyperemic_flow = 3.2 + 0.05 * age - 0.000525 * age ** 2;
        return hyperemic_flow - 0.018 * stenosis_d + 0.00056 * stenosis_d ** 2 - 0.0000085 * stenosis_d ** 3;
    }

    function parseFloatInput(value) {
        return parseFloat(value.toString().replace(',', '.'));
    }

    const onChangeHeartRate = (e) => {
        dispatch(setHeartRate(e.target.value == "" ? false : parseInt(e.target.value)));
    };

    const onChangeLvMyocardiumMass = (e) => {
        let inputValue = e.target.value;
        inputValue = inputValue.replace('.', ',');
        if (inputValue == "" || /^\d+,?\d*$/.test(inputValue)) {
            inputValue = inputValue.replace(',', '.');
            setLvMyocardiumMass_(inputValue);
            inputValue = inputValue == "" ? false : parseFloat(inputValue);
            dispatch(setLvMyocardiumMass(inputValue));
        }
    };

    const onChangeModelType = (e) => {
        if (e.target.value == "cfd" || e.target.value == "pinn") {
            dispatch(setModelType(e.target.value));
        }
    };

    const toggleBlock = (event) => {
        const targetBlock = event.target.parentElement;
        targetBlock.classList.toggle('active', !targetBlock.classList.contains('active'));
    }

    const activateVessel = (vessel) => {
        dispatch(setActiveVessel(vessel));
    }

    function isCalculationAllowed() {
        const age = parseInt(supplementary["pinn"]["age"]);
        return (
            Object.keys(uploadedVessels).length > 0 &&
            !isNaN(heartRate) && heartRate > 0 &&
            !isNaN(lvMyocardiumMass) && lvMyocardiumMass > 0 &&
            !isNaN(age) && age > 0
        );
    }

    function completeRequestForCFD(body, vessel) {
        Object.keys(supplementary["cfd"]).forEach(key => {
            if (supplementary["cfd"][key] !== "") {
                if (
                    key == "gradient_version" ||
                    key == "hyperemia" ||
                    key == "stenosis_mode" ||
                    key == "q_function_type" ||
                    key == "use_fake_values" ||
                    key == "velocity_profile"
                ) {
                    body[key] = parseInt(supplementary["cfd"][key]);
                } else {
                    body[key] = parseFloatInput(supplementary["cfd"][key]);
                }
            }
        })

        if (body.hasOwnProperty('q_function_type')) {
            body.q_function_type = (body.q_function_type == 1) ? "sinusoid" : "physiological";
        }

        if (
            body.hasOwnProperty('windkessel_c') ||
            body.hasOwnProperty('windkessel_r1') ||
            body.hasOwnProperty('windkessel_r2')
        ) {
            body.windkessel_params = {
                "C": body.windkessel_c,
                "R1": body.windkessel_r1
            }
            delete body.windkessel_c;
            delete body.windkessel_r1;
            if (body.hasOwnProperty('windkessel_r2')) {
                body.windkessel_params.R2 = body.windkessel_r2;
                delete body.windkessel_r2;
            }
        }

        if (body.hasOwnProperty('elasticity_k1') || body.hasOwnProperty('elasticity_k2') || body.hasOwnProperty('elasticity_k3')) {
            body.elasticity = {
                "k1": body.elasticity_k1,
                "k2": body.elasticity_k2,
                "k3": body.elasticity_k3
            }
            delete body.elasticity_k1;
            delete body.elasticity_k2;
            delete body.elasticity_k3;
        }

        if (body.hasOwnProperty('p0')) {
            // Pa to dPa
            body['p0'] = body['p0'] * 10;
        }
        return body;
    }

    function completeRequestForPINN(body, vessel) {
        Object.keys(supplementary["pinn"]).forEach(key => {
            if (key == "myocardium_mass_multiplier" || key == "murrey_exponent") {
                return;
            }
            if (supplementary["pinn"][key] !== "") {
                if (
                    key == "hyperemia" ||
                    key == "age" ||
                    key == "gender" ||
                    key == "diabetes" ||
                    key == "hypertension" ||
                    key == "previous_pci" ||
                    key == "previous_mi_history" ||
                    key == "tobacco_abuse"
                ) {
                    body[key] = parseInt(supplementary["pinn"][key]);
                } else {
                    body[key] = parseFloat(supplementary["pinn"][key].toString().replace(',', '.'));
                }
            }
        })
        if (
            body.hasOwnProperty('windkessel_c') ||
            body.hasOwnProperty('windkessel_r1') ||
            body.hasOwnProperty('windkessel_r2')
        ) {
            body.windkessel_params = {
                "C": body.windkessel_c,
                "R1": body.windkessel_r1
            }
            delete body.windkessel_c;
            delete body.windkessel_r1;
            if (body.hasOwnProperty('windkessel_r2')) {
                body.windkessel_params.R2 = body.windkessel_r2;
                delete body.windkessel_r2;
            }
        }
        if (body.hasOwnProperty('p0')) {
            // Pa to dPa
            body['p0'] = body['p0'] * 10;
        }
        return body;
    }

    async function runCalculation() {
        if (isCalculationAllowed()) {
            let calculatedVessels = 0;
            const mmm = parseFloatInput(supplementary["pinn"]["myocardium_mass_multiplier"]);
            const murray_exponent = parseFloatInput(supplementary["pinn"]["murrey_exponent"]);
            const hyperemia = parseInt(supplementary["pinn"]["hyperemia"]);
            const q_lv = mmm * (1.2 * lvMyocardiumMass) ** 0.75;
            const sum_of_radii = Object.values(radii).reduce((sum, r) => sum + r ** murray_exponent, 0);

            Object.keys(uploadedVessels).forEach(vessel => {
                const activeVesselJSON = vesselJSON.find(v => v.vessel == vessel.toLowerCase());
                if (!activeVesselJSON) {
                    return;
                }
                const q_rest = q_lv * (radii[vessel] ** murray_exponent) / sum_of_radii;
                const myocardium_mass = (q_rest / mmm) ** (4/3);
                let k_hyperemia = 1;
                if (hyperemia == 1) {
                    const stenosis_d = activeVesselJSON.stenosis.D;
                    const age = parseInt(supplementary["pinn"]["age"]);
                    k_hyperemia = calculateKHyperemia(stenosis_d, age);
                }
                const q_integral = (vessel == "rca") ? 0.654962 : 1.16134;
                const max_time = 60 / heartRate;
                let q_inflow = q_integral * q_rest * k_hyperemia / max_time;
                if (bifurcations[vessel]) {
                    Object.values(bifurcations[vessel]).forEach(bifurcation => {
                        const main_radius = parseFloat(bifurcation["main_radius"]);
                        const daughter_radius = parseFloat(bifurcation["daughter_radius"]);
                        q_inflow = q_inflow * (main_radius ** murray_exponent) / (daughter_radius ** murray_exponent + main_radius ** murray_exponent);
                    });
                }
                // ml/min to ml/s
                q_inflow = q_inflow / 60;

                let body = {
                    myocardium_mass: myocardium_mass,
                    mean_q: q_inflow,
                    heart_rate: Number(heartRate),
                    vessel: vessel.toLowerCase(),
                    center_line: activeVesselJSON.center_line,
                    sections: activeVesselJSON.sections,
                    stenosis: {
                        "A": activeVesselJSON.stenosis.A,
                        "D": activeVesselJSON.stenosis.D,
                        "length": activeVesselJSON.stenosis.length,
                        "lumen": activeVesselJSON.stenosis.lumen,
                        "segment_number": 5
                    }
                };

                dispatch(setOverlayStatus("loading"));
                dispatch(setFFRCalculationStatus(false));
                // reset values from the previous calculation
                ["lad", "lcx", "rca"].forEach(vesselKey => {
                    dispatch(setFFR({ vessel: vesselKey, ffr: false, x: false }));
                    dispatch(setPrintCamera({ 
                        type: vesselKey, 
                        data: {
                            position: { x: false, y: false, z: false },
                            rotation: { x: false, y: false, z: false }
                        }
                    }));
                });

                modelPollingPromise(
                    (modelType == "pinn") ? "pinn" : "cfd",
                    (modelType == "pinn") ? completeRequestForPINN(body, vessel) : completeRequestForCFD(body, vessel)
                )
                    .then(response => {
                        const result = response.data.result.result;
                        if (result) {
                            dispatch(setVesselInfo({
                                info: {
                                    ffr: result.ffr.value,
                                    ffr_position: result.ffr_position,
                                    center_line: activeVesselJSON.center_line,
                                    additional_info: result.additional_info
                                },
                                vessel: vessel
                            }));
                            const target = parseFloat(result.ffr_position);
                            let closestIdx = 0;
                            let closestDist = Infinity;
                            for (let i = 0; i < activeVesselJSON.center_line.length; i++) {
                                const dist = Math.abs(parseFloat(activeVesselJSON.center_line[i].d) - target);
                                if (dist < closestDist) {
                                    closestDist = dist;
                                    closestIdx = i;
                                }
                            }
                            dispatch(setFFR({
                                vessel: vessel,
                                ffr: parseFloat(result.ffr.value[closestIdx]).toFixed(2),
                                x: parseFloat(activeVesselJSON.center_line[closestIdx].d).toFixed(1)
                            }));
                        } else {
                            // TODO: log error
                        }
                    })
                    .catch(() => {
                        // TODO: log error
                    })
                    .finally(() => {
                        dispatch(setOverlayStatus(false));
                        calculatedVessels++;
                        if (calculatedVessels == Object.keys(uploadedVessels).length) {
                            fileStorage.removeFileByName('coloring');
                            dispatch(setFile({ name: 'coloring', link: false }));
                            dispatch(setFFRCalculationStatus(true));
                        }
                    });
            });
        }
    };

    return (
        <div className="nav-items">
            <div className="nav-block active mb-2">
                <div className="title-nav-clickable title-nav" onClick={toggleBlock}>
                    General information
                </div>
                <div className="nav-block-content">
                    {/* TODO: model type selection is disabled for now */}
                    {/* 
                    <div className="d-flex align-items-center text-white mb-2 mt-2">
                        <p className="mb-0 title-meas">Model type</p>
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center mb-2">
                                <input id="model_type_cfd" onChange={(e) => onChangeModelType(e)}
                                    className="input-measurements me-2"
                                    name="model_type"
                                    checked={modelType == "cfd" ? "checked" : ""}
                                    type="radio"
                                    value="cfd" />
                                <label htmlFor="model_type_cfd">
                                    CFD
                                </label>
                            </div>
                            <div className="d-flex align-items-center">
                                <input id="model_type_pinn" onChange={(e) => onChangeModelType(e)}
                                    className="input-measurements me-2"
                                    name="model_type"
                                    checked={modelType == "pinn" ? "checked" : ""}
                                    type="radio"
                                    value="pinn" />
                                <label htmlFor="model_type_pinn" className="ml-2">PINN</label>
                            </div>
                        </div>
                    </div>
                    */}
                    
                    <PINNGeneral />
                    <hr className="text-white"/>
                    <div className="d-flex align-items-center text-white">
                        <p className="mb-0 title-meas">Heart rate</p>
                        <input onChange={(e) => onChangeHeartRate(e)}
                            className="input-measurements me-2"
                            type="text"
                            value={heartRate ? heartRate : ""} />
                        <p className="mb-0">bpm</p>
                    </div>
                    <div className="d-flex align-items-center text-white mb-2">
                        <p className="mb-0 title-meas">Myocardium mass (left ventricle)</p>
                        <input onChange={(e) => onChangeLvMyocardiumMass(e)}
                            className="input-measurements me-2"
                            type="text"
                            value={lvMyocardiumMass_ ? formatInputNumber(lvMyocardiumMass_) : ""} />
                        <p className="mb-0">g</p>
                    </div>
                </div>
            </div>
            <div className="nav-block active">
                <div className="title-nav-clickable title-nav" onClick={toggleBlock}>
                    Coronary artery
                </div>
                <div className="nav-block-content">
                    <div className="d-flex align-items-center justify-content-between text-white mt-2 mb-2">
                    {Object.keys(uploadedVessels).map((vessel) => (
                        <div key={vessel} className="d-flex align-items-center me-3">
                        <input
                            id={`vessel_${vessel}`}
                            onChange={() => activateVessel(vessel)}
                            className="input-measurements me-2"
                            name="vessel"
                            checked={vessel === activeVessel}
                            type="radio"
                            value={vessel}
                        />
                        <label className="mb-0" htmlFor={`vessel_${vessel}`}>
                            {vessel.toUpperCase()}
                        </label>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
            <PINNSupplementary />
            <div className="mb-2 pb-3">
                <button onClick={runCalculation}
                    className={isCalculationAllowed() ? "calc-btn mt-3" : "calc-btn mt-3 disabled"}>
                    Calculate
                </button>
            </div>
        </div>
    );
}

export default LeftNav;
